var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app--square-container"},[_c('div',{staticClass:"app--square",class:{
			'app--square-yellow': !_vm.hasStyle,
			'app--square-red': _vm.hasStyle && Number(_vm.id)%2===0,
			'app--square-blue': _vm.hasStyle && Number(_vm.id)%2!==0},style:({visibility: _vm.display? 'visible': 'hidden'})})])}
var staticRenderFns = []

export { render, staticRenderFns }